export const joinPath = function () {
  for (var _len = arguments.length, parts = new Array(_len), _key = 0; _key < _len; _key++) {
    parts[_key] = arguments[_key];
  }

  const realParts = parts.filter(part => !!part);
  return realParts.map(part => part.replace(/^\/+|\/+$/g, '')).join('/');
};